// extracted by mini-css-extract-plugin
module.exports = {"main":"MainApp_main__2HKNq","article-content":"MainApp_article-content__1_qL-","projects-title":"MainApp_projects-title__3pRHH"};